export default "__VITE_ASSET__9dceeca7__"